module.exports = __webpack_public_path__ + "6fce27be4007b49a8c243ed6fe8c110b.jpg";